import { all, put, call, takeEvery } from "redux-saga/effects";
// import { api_base_url } from "../../util/BaseUrl";
import { actionTypes, loginSuccess, logOutSuccess } from "./action";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// const APIURL = "http://192.168.1.20:8002/shambasync/v1";
// const APIURL = "http://192.168.17.58:8002/shambasync/v1";
const APIURL = "https://marketplace.shambasync.com/shambasync/v1";

// polyfill();
const modalSuccess = (type) => {
  alert("You have successfully Logged In!");
};

const modalWarning = (type) => {
 alert("Your account has been logged out!");
};

const modalError = (message) => {
  alert(message);
};

function* loginSaga({ type, payload }) {
  try {
    const data = yield call(APIURL + "/", payload);
    if (data && data.authorization) {
      data.isLoggedIn = true;
      yield put(loginSuccess(data, type));
      modalSuccess("success");
    } else if (data.data === null) {
      modalWarning(data.message);
    } else {
      if (JSON.parse(data.error).message.includes("404")) {
        modalWarning("not found");
      }
      if (JSON.parse(data.error).message.includes("400")) {
        modalError("Invalid Password.");
      }
    }
  } catch (err) {
    modalWarning("warning");
  }
}

function* logOutSaga() {
  try {
    yield put(logOutSuccess());
    toast.success("Logged out successfully! See you soon!", {
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
    // modalWarning("warning");
    // Router.push("/dashboard/");
  } catch (err) {
    toast.error("Logout failed");
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actionTypes.LOGIN_REQUEST, loginSaga)]);
  yield all([takeEvery(actionTypes.LOGOUT, logOutSaga)]);
}
